export default __webpack_public_path__ + "static/media/service08.abf99224.png";